export const ENDPOINTS = {
  getUserData: "/cassowary/session/getuser",
  getMasterData: "/v1/master-data",
  allServices:"/hoatzin/inventory/all-services"
};
